var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "footer" }, [
      _c("div", { staticClass: "ethics-hotline float-l col-12" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "speakup-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "loading-container",
                    staticStyle: { display: "none" }
                  },
                  [
                    _c("div", { staticClass: "loading" }, [
                      _c("img", {
                        attrs: { src: "/static/images/loading.gif" }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href:
                        "https://secure.ethicspoint.com/domain/media/en/gui/92280/index.html"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "speakup-image",
                      attrs: { src: "/static/images/speak_up_line.png" }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "speakup-detalis" }, [
                _c("img", {
                  staticClass: "spack-up-img spackup-img-left",
                  attrs: { src: "/static/images/vector.png", alt: "" }
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                        At Velocity Vehicle Group and our affiliated companies, we are committed to doing business ethically, with integrity, and in compliance with the law. We can only achieve this commitment if we are all confident we can speak up with questions, concerns, or suggestions. We hope that you are all comfortable speaking directly with me, HR, or your manager, but in those cases when you are not, please use this Speak Up Line to contact us about your questions, concerns, or suggestions. We value your opinion and want to hear from you!\n                        "
                  ),
                  _c("span", [
                    _vm._v("-Jeffrey Swett, Chief Compliance Officer")
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "spack-up-img spackup-img-right",
                  attrs: { src: "/static/images/Vector-1.png", alt: "" }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da50d10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da50d10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = null
// module chunks = 